import { ProgressBarDesignTokens } from '@primeuix/themes/aura/progressbar';

export const progressBarTokens: ProgressBarDesignTokens = {
  root: {
    background: '{content.border.color}',
    borderRadius: '{content.border.radius}',
    height: '0.5rem',
  },
  value: {
    background: '{primary.color}',
  },
  label: {
    color: '{primary.contrast.color}',
    fontSize: '0.75rem',
    fontWeight: '600',
  },
};
